class Accordion {
  constructor(element) {
    this.element = element;
    this.panel = element.querySelector('[js-accordion-panel]')
    this.button = element.querySelector('[js-accordion-button]')

    this.open = false;
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => {
      this.element.classList[this.open ? 'remove' : 'add']('active');
      this.panel.style.maxHeight = this.open ? '0px' : `${this.panel.scrollHeight}px`;

      this.open = !this.open;
    })
  }
}

export default Accordion;
